import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';
import { useToasts } from '../hooks/useToasts';
import Form from '../components/Form';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const { addToast } = useToasts();


    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            await forgotPassword(email);
            setSuccess(true);
        } catch (err) {
            const errorMsg = err.response?.data?.details?.[0] || 'Failed to send reset link';
            addToast(errorMsg, 'error-warning');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <Form
                title="Check Your Email"
                showCancel={false}
                showSubmit={false}
                footerLinks={
                    <Link to="/login">Back to Login</Link>
                }
            >
                <p className="success-message">
                    We've sent a password reset link to <strong>{email}</strong>
                </p>
                <p>Please check your inbox and click the link to reset your password.</p>
            </Form>
        );
    }

    return (
        <Form
            title="Forgot Password"
            onSubmit={handleSubmit}
            error={null}
            loading={loading}
            submitText="Send Reset Link"
            showCancel={false}
            footerLinks={
                <Link to="/login">Back to Login</Link>
            }
        >
            <p>Enter your email address and we'll send you a link to reset your password.</p>
            <label htmlFor="email">
                Email
                <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                />
            </label>
        </Form>
    );
}

export default ForgotPassword;
